<form [formGroup]="form" class="flex flex-col">
    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <app-application-form-field
            fieldNumber="9"
            [tooltipMessage]="messages.applicationFeeExemption"
            [showTooltipIcon]="false"
            class="w-full xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Application Fee Exemption</mat-label>
                <mat-select formControlName="applicationFeeExempt" required>
                    @for (
                        yesNoOption of yesNoOptions;
                        track yesNoOption.value
                    ) {
                        <mat-option [value]="yesNoOption.value">{{
                            yesNoOption.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
        <app-application-form-field
            fieldNumber="10"
            label="Regulatory Fee Exemption"
            [tooltipMessage]="messages.regulatoryFeeExemption"
            [showTooltipIcon]="false"
            class="w-full xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Regulatory Fee Exemption</mat-label>
                <mat-select formControlName="regulatoryFeeExempt" required>
                    @for (
                        yesNoOption of yesNoOptions;
                        track yesNoOption.value
                    ) {
                        <mat-option [value]="yesNoOption.value">{{
                            yesNoOption.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div
            class="flex-row items-start w-full xl:col-span-1 grid grid-cols-12 gap-3 mb-5"
        >
            <app-application-form-field
                fieldNumber="11a"
                [tooltipMessage]="messages.waiverRequest"
                [ellipsisLength]="59"
                class="w-full"
                [ngClass]="
                    form.controls.requestingAWaiver.value
                        ? 'col-span-8'
                        : 'col-span-12'
                "
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Waiver Request</mat-label>
                    <mat-select formControlName="requestingAWaiver" required>
                        @for (
                            yesNoOption of yesNoOptions;
                            track yesNoOption.value
                        ) {
                            <mat-option [value]="yesNoOption.value">{{
                                yesNoOption.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
            @if (form.controls.requestingAWaiver.value) {
                <div class="flex col-span-4">
                    <app-attachment-required-button class="w-full" />
                </div>
            }
        </div>

        <app-application-form-field
            fieldNumber="12"
            label="Grandfathered/Previous Approval"
            [tooltipMessage]="messages.grandfatheredPrivileges"
            [ellipsisLength]="58"
            class="w-full xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Grandfathered/Previous Approval</mat-label>
                <mat-select
                    formControlName="grandfatheredApprovedIntegrator"
                    required
                >
                    @for (
                        yesNoOption of yesNoOptions;
                        track yesNoOption.value
                    ) {
                        <mat-option [value]="yesNoOption.value">{{
                            yesNoOption.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div class="mt-10">
        <app-attachment-grid
            [applicationId]="applicationId!"
        ></app-attachment-grid>
    </div>
</form>
